var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70833 5.41663C5.70833 2.98811 7.65482 1.04163 10.0833 1.04163C12.5118 1.04163 14.4583 2.98811 14.4583 5.41663C14.4583 7.84514 12.5118 9.79163 10.0833 9.79163C7.65482 9.79163 5.70833 7.84514 5.70833 5.41663ZM10.0833 2.29163C8.34518 2.29163 6.95833 3.67847 6.95833 5.41663C6.95833 7.15478 8.34518 8.54163 10.0833 8.54163C11.8215 8.54163 13.2083 7.15478 13.2083 5.41663C13.2083 3.67847 11.8215 2.29163 10.0833 2.29163ZM7.16659 12.9583C5.43713 12.9583 3.95825 14.4197 3.95825 16.2499V18.3333C3.95825 18.6785 3.67843 18.9583 3.33325 18.9583C2.98807 18.9583 2.70825 18.6785 2.70825 18.3333V16.2499C2.70825 13.7469 4.72938 11.7083 7.16659 11.7083H12.9999C15.4371 11.7083 17.4583 13.7469 17.4583 16.2499V18.3333C17.4583 18.6785 17.1784 18.9583 16.8333 18.9583C16.4881 18.9583 16.2083 18.6785 16.2083 18.3333V16.2499C16.2083 14.4197 14.7294 12.9583 12.9999 12.9583H7.16659Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.99f8ccaa8e33c82146c33c431b111167.svg";
export { ForwardRef as ReactComponent };